import { FunctionSwitchList } from './FunctionSwitchList';
import {
  FunctionSwitchHotSlaveDetail,
  FunctionSwitchFoodyIntegrationDetail,
  FunctionSwitchAutoAcceptFoodyOrdersDetail,
  FunctionSwitchEpaymentDetail,
  FunctionSwitchAssembledOrderLoadingInReportDetail,
  FunctionSwitchNewMenuService,
} from './FunctionSwitchDetail';
import FunctionSwitchAddWhitelist from './FunctionSwitchAddWhitelist';
import FunctionSwitchRemoveWhitelist from './FunctionSwitchRemoveWhitelist';
import FunctionSwitchEditWhitelist from './FunctionSwitchEditWhitelist';
import ImportFoodyMenu from "./ImportFoodyMenu";

import ExtendMembership from './ExtendMembership';
import ExtendMembershipUpdate from './ExtendMembershipUpdate';

import { ReminderConfigList } from './ReminderConfigList';
import { ReminderConfigUpdateDetail } from './ReminderConfigUpdateDetail';
import { ReminderConfigUpdateEdit } from './ReminderConfigUpdateEdit';
import { ReminderConfigDropDetail } from './ReminderConfigDropDetail';
import { ReminderConfigDropEdit } from './ReminderConfigDropEdit';

import PremiumShopDeactivatePremiumShop from './PremiumShopDeactivatePremiumShop';
import PremiumShopTransferPrimary from './PremiumShopTransferPrimary';
import PremiumShopUnmergeBranch from './PremiumShopUnmergeBranch';
import PremiumShopList from './PremiumShopList';

import NowOchaShopsList from './NowOchaShopsList';
import NowOchaChangeDeliveryStatus from './NowOchaChangeMappingStatus';

import DualScreenAdList from './DualScreenAdList';
import DualScreenAdDetail from './DualScreenAdDetail';
import DualScreenAdCreate from './DualScreenAdCreate';
import DualScreenAdEdit from './DualScreenAdEdit';

import * as urls from './urls';
import * as utils from './utils';
import { RestrictedPage } from 'routes/CrudRoute';
import {
  COUNTRY_TH,
} from 'util/constants';

const AdvancedFunctionResources = [
  {
    "name": utils.FunctionSwitchResourceName,
    "frontendPath": urls.functionSwitchFrontendPath,
    "backendPath": urls.functionSwitchBackendPath,
    "list": FunctionSwitchList,
    "showInSideMenu": true,
  },
  {
    "name": utils.FunctionSwitchHotSlaveResourceName,
    "frontendPath": urls.functionSwitchHotSlaveFrontendPath,
    "backendPath": urls.functionSwitchHotSlaveBackendPath,
    "list": FunctionSwitchHotSlaveDetail,
    "showInSideMenu": false,
  },
  {
    "name": utils.FunctionSwitchFoodyIntegrationResourceName,
    "frontendPath": urls.functionSwitchFoodyIntegrationFrontendPath,
    "backendPath": urls.functionSwitchFoodyIntegrationBackendPath,
    "list": FunctionSwitchFoodyIntegrationDetail,
    "showInSideMenu": false,
  },
  {
    "name": utils.FunctionSwitchAutoAcceptDeliveryOrdersResourceName,
    "frontendPath": urls.functionSwitchAutoAcceptFoodyOrdersFrontendPath,
    "backendPath": urls.functionSwitchAutoAcceptFoodyOrdersBackendPath,
    "list": FunctionSwitchAutoAcceptFoodyOrdersDetail,
    "showInSideMenu": false,
  },
  {
    "name": utils.FunctionSwitchAutoAcceptDeliveryOrdersResourceName,
    "frontendPath": urls.functionSwitchEpaymentFrontendPath,
    "backendPath": urls.functionSwitchEpaymentBackendPath,
    "list": FunctionSwitchEpaymentDetail,
    "showInSideMenu": false,
  },
  {
    "name": utils.FunctionSwitchAssembledOrderLoadingInReportResourceName,
    "frontendPath": urls.functionSwitchAssembledOrderLoadingInReportFrontendPath,
    "backendPath": urls.functionSwitchAssembledOrderLoadingInReportBackendPath,
    "list": FunctionSwitchAssembledOrderLoadingInReportDetail,
    "showInSideMenu": false,
  },
  {
    "name": utils.FunctionSwitchNewMenuServiceResourceName,
    "frontendPath": urls.functionSwitchNewMenuServiceFrontendPath,
    "backendPath": urls.functionSwitchNewMenuServiceBackendPath,
    "list": FunctionSwitchNewMenuService,
    "showInSideMenu": false,
  },
  {
    "name": utils.PremiumShopResourceName,
    "frontendPath": urls.premiumShopFrontendPath,
    "backendPath": urls.premiumShopBackendPath,
    "list": PremiumShopList,
    "showInSideMenu": true,
  },
  {
    "name": utils.NowOchaShopResourceName,
    "frontendPath": urls.nowOchaShopsFrontendPath,
    "backendPath": urls.nowOchaShopsBackendPath,
    "list": NowOchaShopsList,
    "showInSideMenu": true,
  },
  {
    "name": utils.ReminderConfigResourceName,
    "frontendPath": urls.reminderConfigFrontendPath,
    "backendPath": urls.reminderConfigBackendPath,
    "list": ReminderConfigList,
    "showInSideMenu": true,
  },
  {
    "name": utils.ExtendMembershipResourceName,
    "frontendPath": urls.extendMembershipFrontendPath,
    "backendPath": urls.extendMembershipBackenddPath,
    "list": ExtendMembership,
    "showInSideMenu": true,
  },
];

const AdvancedFunctionCustomRoutes = [
  {
    "name": "Add new shop",
    "frontendPath": urls.functionSwitchAddWhitelistFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(FunctionSwitchAddWhitelist, "Add whitelist", {
      "resource": utils.FunctionSwitchResourceName,
      "redirectPath": urls.functionSwitchFrontendPath,
    })
  },
  {
    "name": "Remove shop",
    "frontendPath": urls.functionSwitchRemoveWhitelistFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(FunctionSwitchRemoveWhitelist, "Remove whitelist", {
      "resource": utils.FunctionSwitchResourceName,
      "redirectPath": urls.functionSwitchFrontendPath,
    })
  },
  {
    "name": "Edit shop",
    "frontendPath": urls.functionSwitchEditWhitelistFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(FunctionSwitchEditWhitelist, "Edit whitelist", {
      "resource": utils.FunctionSwitchResourceName,
      "redirectPath": urls.functionSwitchFrontendPath,
    })
  },
  {
    "name": "Membership extension",
    "frontendPath": urls.extendMembershipUpdateFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(ExtendMembershipUpdate, "", {
      "resource": utils.ExtendMembershipResourceName,
      "redirectPath": urls.extendMembershipFrontendPath,
    })
  },
  {
    "name": "Unmerge branch",
    "frontendPath": urls.premiumShopUnmergeBranchFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(PremiumShopUnmergeBranch, "", {
      "resource": utils.PremiumShopResourceName,
      "redirectPath": urls.premiumShopFrontendPath,
    })
  },
  {
    "name": "Transfer primary",
    "frontendPath": urls.premiumShopTransferPrimaryFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(PremiumShopTransferPrimary, "", {
      "resource": utils.PremiumShopResourceName,
      "redirectPath": urls.premiumShopFrontendPath,
    })
  },
  {
    "name": "Change Delivery Status",
    "frontendPath": urls.nowOchaShopsChangeDeliveryFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(NowOchaChangeDeliveryStatus, "", {
      "resource": utils.NowOchaShopResourceName,
      "redirectPath": urls.nowOchaShopsFrontendPath,
    })
  },
  {
    "name": "Deactivate premium shop",
    "frontendPath": urls.premiumShopDeactivateFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(PremiumShopDeactivatePremiumShop, "", {
      "resource": utils.PremiumShopResourceName,
      "redirectPath": urls.premiumShopFrontendPath,
    })
  },
  {
    "name": "Import Foody Menu",
    "frontendPath": urls.importFoodyMenuFrontendPath,
    "showInSideMenu": true,
    "render": RestrictedPage(ImportFoodyMenu, '', {
      "redirectPath": '/',
    })
  },
  {
    "name": "View New Update Reminder",
    "frontendPath": urls.reminderConfigUpdateDetailFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(ReminderConfigUpdateDetail, "", {
      "resource": utils.ReminderConfigResourceName,
      "redirectPath": urls.reminderConfigFrontendPath,
    })
  },
  {
    "name": "Edit New Update Reminder",
    "frontendPath": urls.reminderConfigUpdateEditFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(ReminderConfigUpdateEdit, "", {
      "resource": utils.ReminderConfigResourceName,
      "redirectPath": urls.reminderConfigFrontendPath,
    })
  },
  {
    "name": "View Dropping Version",
    "frontendPath": urls.reminderConfigDropDetailFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(ReminderConfigDropDetail, "", {
      "resource": utils.ReminderConfigResourceName,
      "redirectPath": urls.reminderConfigFrontendPath,
    })
  },
  {
    "name": "Edit Dropping Version",
    "frontendPath": urls.reminderConfigDropEditFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(ReminderConfigDropEdit, "", {
      "resource": utils.ReminderConfigResourceName,
      "redirectPath": urls.reminderConfigFrontendPath,
    })
  },
];


if (process.env.REACT_APP_COUNTRY === COUNTRY_TH) {
  AdvancedFunctionResources.push({
    "name": utils.DualScreenAdResourceName,
    "frontendPath": urls.dualScreenAdListFrontendPath,
    "backendPath": urls.dualScreenAdListBackendPath,
    "list": DualScreenAdList,
    "create": DualScreenAdCreate,
    "showInSideMenu": true,
  });

  AdvancedFunctionCustomRoutes.push({
    "name": utils.DualScreenAdResourceName,
    "frontendPath": urls.dualScreenAdDetailFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(DualScreenAdDetail, "", {
      "resource": utils.DualScreenAdResourceName,
      "redirectPath": urls.dualScreenAdListFrontendPath,
    })
  });

  AdvancedFunctionCustomRoutes.push({
    "name": utils.DualScreenAdResourceName,
    "frontendPath": urls.dualScreenAdEditFrontendPath,
    "editBackendPath": urls.dualScreenAdEditBackendPath,
    "detailBackendPath": urls.dualScreenAdDetailBackendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(DualScreenAdEdit, 'extend', {
      "resource": utils.DualScreenAdResourceName,
      "editBackendPath": urls.dualScreenAdEditBackendPath,
      "detailBackendPath": urls.dualScreenAdDetailBackendPath,
      'updateDataOnMount': true,
      'redirectPath': urls.dualScreenAdListFrontendPath,
    })
  });
}


export {
  AdvancedFunctionResources,
  AdvancedFunctionCustomRoutes
};



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/resources.js